import {Component} from '@angular/core';
import {GlobalsService} from "@services/micro/globals.service";
import { AmpassengerButtonSelectComponent } from '../ampassenger-button-select/ampassenger-button-select.component';
import { KioskPermissionsService } from '@services/kiosk-permissions.service';
/**
  Componente que extiende la funcionalidad de `AmpassengerButtonSelectComponent` para manejar
  la selección de pasajeros en el contexto de la gestión de programas de viajero frecuente (FNN).
  Este componente permite verificar y gestionar la información del programa de viajero frecuente
  de un pasajero, mostrando íconos y estados personalizados según la información proporcionada.
**/
export type TypeTemplateButton = 'passenger' | 'bags';
@Component({
    selector: 'am-ampassenger-button-select-fnn',
    templateUrl: './ampassenger-button-select-fnn.component.html',
    styleUrls: ['./ampassenger-button-select-fnn.component.scss'],
    standalone: false
})

export class AmpassengerButtonSelectFnnComponent extends AmpassengerButtonSelectComponent {

  constructor(
    public _global: GlobalsService,
    _kioskPermissions: KioskPermissionsService
  ) {
    super(_global, _kioskPermissions);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

   /**
    Obtiene el texto traducido correspondiente al estado del programa de viajero frecuente del pasajero.
    @return {string} Texto traducido del estado.
  **/
  override get copyEstatus(){
    const validFFN = this.passanger.passengerInfo?.ffNumber  ? 'passengerSelection.passengerButton.documentsFFn' : 'passengerSelection.passengerButton.notDocuments';
    const validPass = this.passanger?.passengerInfo?.passport?.passportScanned ? 'modalVerPass.btverifyes' : 'modalVerPass.titlePassengers';
    return this.isVerPass ? validPass : validFFN;
  }
  /**
    Obtiene la ruta del ícono correspondiente al estado del programa de viajero frecuente del pasajero.
    @return {string} Ruta del ícono.
  **/
  override get getIconEstatus() {
    const iconFFN = this.statusFFn ? './assets/images/formCorrect.svg' : './assets/images/formIncorrect.svg';
    const iconPass = this.passanger?.passengerInfo?.passport?.passportScanned ? './assets/images/formCorrect.svg' : './assets/images/alertBlue.svg';
    return this.isVerPass ? iconPass : iconFFN;
  }
  /**
    Verifica si el pasajero tiene un número de viajero frecuente y un programa válidos.
    @return {boolean} `true` si el pasajero tiene un número y programa de viajero frecuente válidos, `false` en caso contrario.
  **/
  get statusFFn() {
    const { ffNumber, ffProgram } = this.passanger.passengerInfo;
    return !!ffNumber && !!ffProgram;
  }
  /**
    Indica si el botón de selección debe estar deshabilitado según el estado del programa de viajero frecuente del pasajero.
    @return {boolean} `true` si el botón debe estar deshabilitado, `false` en caso contrario.
  **/
  override get isDisabled() {
    return this.statusFFn ? true : false
  }
    /**
    Indica si se debe mostrar la opción de editar al pasajero según su estado de viajero frecuente.
    @return {boolean} `true` si se debe mostrar la opción de editar, `false` en caso contrario.
  **/

  override get showEdit() {
    if (this.passanger?.isOkToBoard && !this.passanger.checkinStatus) {
      return this.passanger?.isOkToBoard
    }
    return true;
  }

  /**
    Maneja el evento de selección o deselección del pasajero.
    Emite el evento `selected` con el estado de selección.
    @param {boolean} select - Indica si el pasajero ha sido seleccionado (`true`) o deseleccionado (`false`).
    @return void
  **/
  override onSelect(select: boolean): void {
    this.selected.emit(select);
  }
}
